<template>
    <div class="paying-by-card-container">
        <div class="row flex-grow-1">
            <div
                class="col-md-12 banner-horizontal mb-2"
                @click="showGuideOfWoori"
            >
                <WooriCardBanner></WooriCardBanner>
            </div>
            <div class="col-md-12" v-if="!next">
                <b-overlay
                    :show="status === 'loading'"
                >
                    <AssignedAccounts
                        :data="assignedCardAccoutns"
                        @next:page="getPaymentInfo"
                    ></AssignedAccounts>
                </b-overlay>
            </div>
            <div class="col-md-12" v-else>
                <b-overlay
                    :show="status === 'loading'"
                >
                    <PaymentInfo
                        :data="assignedCardPaymentInfo"
                        :user="authUserInfo"
                        @back:page="backPaymentInfo"
                    ></PaymentInfo>
                </b-overlay>
            </div>
        </div>
        <div class="banner-vertical">
            <!-- <img
                class="img-logo"
                src="@/assets/images/woori/card/banner_vertical_logo.png"
            > -->
            <img
                src="@/assets/images/woori/card/banner_vertical.png"
                @click="showGuideOfWoori"
            >
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AssignedAccounts from './_components/AssignedAccounts'
import PaymentInfo from './_components/PaymentInfo'
import WooriCardBanner from './_components/WooriCardBanner'
import useGTag from '@/composables/useGTag'

export default {
    components: {
        AssignedAccounts,
        PaymentInfo,
        WooriCardBanner
    },
    props: {
        accounts: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data () {
        return {
            next: false
        }
    },
    computed: {
        ...mapGetters({
            authUserInfo: 'authUserInfo',
            status: '$_payment_card/status',
            assignedCardAccoutns: '$_payment_card/assignedCardAccoutns',
            assignedCardPaymentInfo: '$_payment_card/assignedCardPaymentInfo'
        })
    },
    methods: {
        ...mapActions({
            fetchAssignedCardPaymentInfo: '$_payment_card/fetchAssignedCardPaymentInfo'
        }),
        getPaymentInfo ({ projectIdxs, assignedIdxs }) {
            this.fetchAssignedCardPaymentInfo({ projectIdxs, assignedIdxs }).then(() => {
                this.next = true
            })
        },
        backPaymentInfo () {
            this.next = false
        },
        showGuideOfWoori () {
            useGTag().trackEvent('hb_card_banner')
            // window.open(`${process.env.VUE_APP_BILLING_URL}/woori-card-guide`)
            // var newWindow = window.open(`${process.env.VUE_APP_BILLING_URL}/woori-card-guide`, 'newwindow', 'width=1200, height=1536, location=no')
            // newWindow.moveTo(150, 0)
            // newWindow.resizeTo(1200, 1536)
            const url = `${process.env.VUE_APP_BILLING_URL}/woori-card-guide`
            const features = 'width=1200,height=1536,location=no,toolbar=no,menubar=no,status=no,scrollbars=yes,resizable=yes,left=150,top=0'
            const newWindow = window.open(url, '_blank', features)

            if (newWindow) {
                // 일부 브라우저는 moveTo, resizeTo 제한될 수 있음
                newWindow.focus()
            } else {
                alert('팝업이 차단되었습니다. 팝업 차단을 해제해 주세요.')
            }
        }
    }
}
</script>

<style>
.paying-by-card-container {
    display: flex;
    cursor: pointer;
}
.banner-horizontal {
    display: none;
}
.banner-vertical {
    margin-left: 36px;
    cursor: pointer;
    position: relative;
}
.banner-vertical .img-logo {
    position: absolute;
    width: 181px;
    left: 50%;
    top: 40px;
    translate: -90px;
}
@media (max-width: 1425px) {
    .banner-horizontal {
        display: block;
    }
    .banner-vertical {
        display: none;
    }
}

</style>
